module.exports = __webpack_public_path__ + "img/onboard-sidebar-image.eed5e9d1.jpg";